import getCurrency from "helpers/currencyHelper";

export interface PriceProps {
  price: number;
  currency: any;
}
export default function Price({ price, currency }: PriceProps) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <span style={{ fontSize: 22 }}>{Intl.NumberFormat().format(price)}</span>
      <span style={{ color: "#8F8F8F" }}>{currency?.en_title ?? getCurrency().defCur.en_title}</span>
    </div>
  );
}
